import React from 'react';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';
import { useNavigate, useSearchParams } from 'react-router-dom';
import SubPageTitle from 'components/_common/panel/SubPageTitle';
import { Box } from 'components/_new/Box';
import { Button } from 'components/_new/Button';
import { useProgramPanel } from 'contexts/programPanelContext';

import { useKnowledgeBase } from 'components/knowledgeBase/knowledgeBaseContext';
import { ModifyArticleForm } from './components/ModifyArticleForm';

export const ProgramKnowledgeBaseArticleAdd = () => {
	const { t } = useTranslation();
	const navigate = useNavigate();
	const { data: program } = useProgramPanel();
	const { knowledgeBaseLinkPrefix } = useKnowledgeBase();

	const [params] = useSearchParams();
	const directoryId = params.get('directory') ? Number(params.get('directory')) : null;

	const handleBackClick = () => {
		if (directoryId) {
			navigate(`${knowledgeBaseLinkPrefix}/directory/${directoryId}`);
		} else {
			navigate(knowledgeBaseLinkPrefix);
		}
	};

	return (
		<>
			<Helmet title={t('knowledgeBase.programPanel.addNewArticleTitle')} />
			<SubPageTitle
				title={t('knowledgeBase.programPanel.addNewArticleTitle')}
				additional={program?.displayName}
				right={() => (
					<Button
						icon="arrow-left"
						variant="primary-text"
						variantSize="sm"
						onClick={handleBackClick}
						label={t('actions.back')}
					/>
				)}
			/>
			<ModifyArticleForm directoryId={directoryId} />
		</>
	);
};
